import React from 'react';
import dynamicfunction from '../utils/dynamicfunction';
import { useSelector } from 'react-redux';
import { textSizes } from '../config/config';
import { cn } from '../utils/utils';
import { fontSizes } from '../constants/constants';

const Text = ({
  text = '',
  weight,
  size,
  color = 'text-dark-grey',
  className,
  isRequired,
  isColon = false,
  onClick,
  isCenter,
  style,
  isDisabled,
  isTruncate = true,
  align,
  dir,
  leftSymbol = false,
  rightSymbol = false,
}) => {
  const { TextWeight, TextAlign, isArabic } = dynamicfunction();

  return (
    <p
      style={{
        fontSize: size ?? fontSizes.h12,
        ...style,
      }}
      className={cn(
        isDisabled ? 'text-dark-grey/60' : color,
        isTruncate && 'truncate',
        weight ? weight : TextWeight.regular,
        isCenter ? 'text-center' : align ? align : TextAlign,
        className,
      )}
      onClick={isDisabled ? null : onClick}
      dir={dir ? dir : isArabic ? 'rtl' : 'ltr'}
    >
      {leftSymbol &&
        (
          <span style={{ fontSize: size ?? fontSizes.h14, color: color }} className={cn(TextWeight.sarSymbol, className)}>
            &#xE900;
          </span>
        )}
      {isColon ? `${text}:` : text}
      {isRequired && <span className='text-red'>*</span>}
      {rightSymbol &&
        (
          <span style={{ fontSize: size ?? fontSizes.h14, color: color }} className={cn(TextWeight.sarSymbol, className)}>
            &#xE900;
          </span>
        )}
    </p>
  );
};

export default Text;
